import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import {
  allTestType,
  AllChemist,
  allSampleManagement,
  AllTestMethod,
} from "../../../../../../../../features/admin/common/Slice";
import Select from "react-select";

import Common_Back_Btn from "../../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingle,
  Update,
  GetAll,
} from "../../../../../../../../features/admin/quality_management/process_requirement/repeatability/Slice";

import { formatDateForInput } from "../../../../../../../../utils/common";
import { useFieldArray } from "react-hook-form";

function Repeatability_Edit_Offcanvas({ show, handleClose, id, refreshData }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const all_test_type = useSelector((state) => state.common.all_test_type);
  const all_chemist = useSelector((state) => state.common.all_chemist);
  const all_sample_management = useSelector(
    (state) => state.common.all_sample_management,
  );
  const all_test_method = useSelector((state) => state.common.all_test_method);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "observations",
  });

  useEffect(() => {
    dispatch(allSampleManagement());
    dispatch(AllTestMethod());
    dispatch(allTestType());
    dispatch(AllChemist());
  }, [dispatch]);

  

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.message;

        //map ID → label
        const testType = all_test_type?.find(
          (o) => o.value === data.test_type_id,
        )?.label;

        const chemist = all_chemist?.find(
          (o) => o.value === data.chemist_assigned_id,
        )?.label;

        const sampleManagement = all_sample_management?.find(
          (o) => o.value === data.sample_id,
        )?.label;

        const testMethod = all_test_method?.find(
          (o) => o.value === data.test_method_id,
        )?.label;

        const observationsData =
          data.Selection_Type_Record_Observations?.map((o) => ({
            value: o.observation_value,
          })) || [];

        reset({
          test_method_id: data.test_method_id || null,
          test_type_id: data.test_type_id || null,
          certified_value: data.certified_value || "",
          average: data.average || "",
          std_deviation: data.std_deviation || "",
          rsd: data.rsd || "",
          chemist_assigned_id: data.checked_by_id || null,
          date: data.date ? formatDateForInput(data.date) : "",
          remark: data.remark || "",
          sample_management_id: data.sample_id || null,
          observations: observationsData,
        });

        replace(observationsData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      show &&
      id &&
      all_test_type?.length &&
      all_chemist?.length &&
      all_sample_management?.length &&
      all_test_method?.length
    ) {
      GetData(id);
    }
  }, [
    show,
    id,
    all_test_type,
    all_chemist,
    all_sample_management,
    all_test_method,
  ]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    try {
      const sendData = {
        test_method_id: data.test_method_id,
        test_type_id: data.test_type_id,
        certified_value: data.certified_value,
        average: data.average,
        std_deviation: data.std_deviation,
        rsd: data.rsd,

        checked_by: data.chemist_assigned_id, 
        sample_id: data.sample_management_id, 

        date: data.date,
        remark: data.remark,

        observations: data.observations.map((o) => o.value),
      };

      const res = await dispatch(Update({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        if (refreshData) 
            refreshData();

        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      } else {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleRemoveCompanies = () => {
    setCompaniesPreview(null);
    setValue("degree", null);
    setRemovedFiles((prev) =>
      prev.includes("degree") ? prev : [...prev, "degree"],
    );
  };

  const handleRemoveAttach = () => {
    setAttachPreview(null);
    setValue("training_certificate", null);
    setRemovedFiles((prev) =>
      prev.includes("training_certificate")
        ? prev
        : [...prev, "training_certificate"],
    );
  };

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Repeatability
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Test Type</Form.Label>
                  <Controller
                    name="test_type_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Test Type is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_test_type}
                        value={
                          all_test_type?.find((o) => o.value === field.value) ||
                          null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.test_type_id && (
                    <span className="text-danger">
                      {errors.test_type_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Sample Id</Form.Label>
                  <Controller
                    name="sample_management_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Sample is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_sample_management}
                        value={
                          all_sample_management?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.sample_management_id && (
                    <span className="text-danger">
                      {errors.sample_management_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Test Method</Form.Label>
                  <Controller
                    name="test_method_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Sample is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_test_method}
                        value={
                          all_test_method?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.test_method_id && (
                    <span className="text-danger">
                      {errors.test_method_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Certified Value</Form.Label>
                  <Form.Control
                    {...register("certified_value", {
                      required: "Certified Value is required",
                    })}
                  />
                  {errors.certified_value && (
                    <span className="text-danger">
                      {errors.certified_value.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Remark</Form.Label>
                  <Form.Control
                    {...register("remark", {
                      required: "Remark is required",
                    })}
                  />
                  {errors.remark && (
                    <span className="text-danger">{errors.remark.message}</span>
                  )}
                </Form.Group>
              </div>

              {/* Observation */}
              <div className="col-12">
                <Form.Group className="form_group">
                  <Form.Label>Observations</Form.Label>

                  <div className="row">
                    {fields.map((field, index) => (
                      <div
                        key={field.id}
                        className="col-xl-2 col-lg-4 col-md-4"
                      >
                        <div className="observation_box">
                          {/* Label */}
                          <div className="obs_label">
                            OBS {String(index + 1).padStart(2, "0")}
                          </div>

                          {/* Input */}
                          <Form.Control
                            {...register(`observations.${index}.value`, {
                              required: "Observation is required",
                            })}
                            defaultValue={field.value} //important for edit
                            onKeyDown={(e) => {
                              if (/[0-9]/.test(e.key)) return;

                              if (
                                e.key === "." &&
                                !e.target.value.includes(".")
                              )
                                return;

                              if (
                                [
                                  "Backspace",
                                  "Delete",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Tab",
                                ].includes(e.key)
                              )
                                return;

                              e.preventDefault();
                            }}
                          />

                          {/* Error */}
                          {errors.observations?.[index]?.value && (
                            <small className="text-danger">
                              {errors.observations[index].value.message}
                            </small>
                          )}

                          {/* Remove button */}
                          {fields.length > 1 && (
                            <button
                              type="button"
                              className="remove_btn"
                              onClick={() => remove(index)}
                            >
                              ❌
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Add button */}
                  <div className="mt-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => append({ value: "" })}
                    >
                      Add Observation
                    </button>
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("date", {
                      required: "Date is required",
                    })}
                  />
                  {errors.date && (
                    <span className="text-danger">{errors.date.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Average</Form.Label>
                  <Form.Control
                    {...register("average", {
                      required: "Average is required",
                    })}
                  />
                  {errors.average && (
                    <span className="text-danger">
                      {errors.average.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Std Deviation</Form.Label>
                  <Form.Control
                    {...register("std_deviation", {
                      required: "Std Deviation is required",
                    })}
                  />
                  {errors.std_deviation && (
                    <span className="text-danger">
                      {errors.std_deviation.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>RSD</Form.Label>
                  <Form.Control
                    {...register("rsd", {
                      required: "RSD is required",
                    })}
                  />
                  {errors.rsd && (
                    <span className="text-danger">{errors.rsd.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Checked By</Form.Label>
                  <Controller
                    name="chemist_assigned_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Chemist is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_chemist}
                        value={
                          all_chemist?.find((o) => o.value === field.value) ||
                          null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.chemist_assigned_id && (
                    <span className="text-danger">
                      {errors.chemist_assigned_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Repeatability_Edit_Offcanvas;
